import { listen as listenLoans } from 'src/store/loans/actions';
import { initialTradingViewSlice } from 'src/store/shared/trading-view/factory';
import { actionOnMessage } from '@skynet/data-ws-mm';
import type { TradingViewState } from 'src/store/shared/trading-view/types';

export const initialState: TradingViewState = {
  data: [],
  status: null,
  error: null,
};

const { actions, reducer } = initialTradingViewSlice({
  prefix: 'loans',
  initialState,
  messages: actionOnMessage,
  extraReducers: (builder) => {
    builder.addCase(listenLoans, (state, action) => {
      const { section, ticker } = action.payload;
      if (section === 'overview' && ticker) {
        state.status = 'pending';
      }
    });
  },
});

export const loanTradingViewActions = { actions, listen: listenLoans };

export default reducer;
